export default __webpack_public_path__ + "static/media/logo-ecco.8820ab6e.jpg";